import { render, staticRenderFns } from "./SpaceEnergy.vue?vue&type=template&id=561321af&scoped=true"
import script from "./SpaceEnergy.vue?vue&type=script&lang=js"
export * from "./SpaceEnergy.vue?vue&type=script&lang=js"
import style0 from "./SpaceEnergy.vue?vue&type=style&index=0&id=561321af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561321af",
  null
  
)

export default component.exports